import './FallbackComponent.css'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { browserLogger } from '../../helpers/browserLogger';

function FallbackComponent({ error, resetErrorBoundary }) {
  // Send structured error to Loki with browser context, stack trace, and breadcrumbs
  browserLogger.error('React ErrorBoundary caught an unhandled error', error, {
    'error.boundary': true,
    'component': 'FallbackComponent',
  });
  return (
    <div role="alert" className='fallbackcontainer'>
      <ErrorOutlineIcon style={{ marginRight: '5px', fontSize: '3rem', color: 'gray' }} />
      <h1>Something went wrong</h1>
      <p>You may refresh the page or try again later</p>
      <button className='rounded-button' onClick={() => window.location.reload()}>Refresh</button>
    </div>
  )
}

export default FallbackComponent
